module.exports = __webpack_public_path__ + "static/img/icn-top.53db6de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn-top.svg
// module id = 8iNc
// module chunks = 10